import { render, staticRenderFns } from "./currencyViewDetail.vue?vue&type=template&id=25529129&scoped=true&"
import script from "./currencyViewDetail.vue?vue&type=script&lang=js&"
export * from "./currencyViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./currencyViewDetail.vue?vue&type=style&index=0&id=25529129&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25529129",
  null
  
)

export default component.exports